import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Costumer } from 'src/app/classes/Costumer';
import { FlatsService } from 'src/app/services/flats.service';
import { Flat } from 'src/app/classes/Flat';
import { httpStatus } from 'src/app/config/httpStatus';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-costumer-flats',
  templateUrl: './costumer-flats.component.html',
  styleUrls: ['./costumer-flats.component.scss']
})
export class CostumerFlatsComponent implements OnInit {

  @Input () costumer: Costumer
  @Output () closeEmitter: EventEmitter<boolean> = new EventEmitter<boolean> ()
  isWorking: boolean
  flats: Flat[]

  constructor(private flatsService: FlatsService, private errorService: ErrorService) {
    this.isWorking = false
    this.flats = []
  }

  ngOnInit() {

    this.flatsService.getFlatsByCostumerId (this.costumer.getId ()).subscribe ((res: any) => {
      
      if (res.status == httpStatus.success) {

        this.flats = res.data

      }

      console.log (this.flats[0])
      
    },(error: HttpErrorResponse) => this.errorService.notifyMainError (error, 'costumer-flats.component.ts'))

  }
  
  closePopup (flag: boolean = false) {
		
		//this.initAnimations = false
		setTimeout (() => { this.closeEmitter.emit (flag) }, 300)
  }
  
  openFlat (flat) {

    let item = {
      promotion: flat.getPromotion (),
      zone: flat.getZone (),
      flat: flat
    }

    this.flatsService.setAllRouteOfFlat (item)

  }

}
